module.exports = __webpack_public_path__ + "img/Eric_Vardon.jpeg";